import useWindowDimensions from './useWindowDimensions';

const TABLET_MIN = 640;
const DESKTOP_MIN = 1024;

/**
 * Returns the current layout breakpoint: 'desktop' | 'tablet' | 'mobile'.
 * Shared by the redesigned detail pages (RetailerView, CampaignView).
 */
const useBreakpoint = () => {
  const { width } = useWindowDimensions();
  if (width >= DESKTOP_MIN) return 'desktop';
  if (width >= TABLET_MIN) return 'tablet';
  return 'mobile';
};

export default useBreakpoint;
